import React, { useEffect, useState } from 'react';
import { Box, Typography, Button, Paper, CircularProgress } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { isAuthenticated } from '../routes/ProtectedRoute';

const NotFound: React.FC = () => {
  const navigate = useNavigate();
  const [countdown, setCountdown] = useState(5);
  const isLoggedIn = isAuthenticated();
  const redirectPath = isLoggedIn ? '/dashboard/overview' : '/login';
  
  // Sarcastic messages array
  const messages = [
    "We've looked everywhere, but this page seems to be on an extended vacation."
  ];
  
  // Randomly select a sarcastic message
  const randomMessage = messages[Math.floor(Math.random() * messages.length)];
  
  useEffect(() => {
    const timer = setInterval(() => {
      setCountdown((prevCount) => {
        if (prevCount <= 1) {
          clearInterval(timer);
          navigate(redirectPath);
          return 0;
        }
        return prevCount - 1;
      });
    }, 1000);
    
    return () => clearInterval(timer);
  }, [navigate, redirectPath]);
  
  const handleRedirectNow = () => {
    navigate(redirectPath);
  };
  
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
        backgroundColor: '#f5f5f5',
        padding: 2
      }}
    >
      <Paper
        elevation={3}
        sx={{
          padding: 4,
          maxWidth: 600,
          textAlign: 'center',
          borderRadius: 2
        }}
      >
        <Typography variant="h1" sx={{ fontSize: '5rem', fontWeight: 'bold', color: '#178EFC', marginBottom: 2 }}>
          404
        </Typography>
        
        <Typography variant="h5" sx={{ marginBottom: 3, color: '#333' }}>
          {randomMessage}
        </Typography>
        
        <Typography variant="body1" sx={{ marginBottom: 4, color: '#666' }}>
          Redirecting you to {isLoggedIn ? 'dashboard' : 'login'} in {countdown} seconds...
        </Typography>
        
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 2 }}>
          <Button
            variant="contained"
            color="primary"
            onClick={handleRedirectNow}
            sx={{ textTransform: 'none' }}
          >
            Take Me There Now
          </Button>
          
          <Box sx={{ position: 'relative', display: 'inline-flex' }}>
            <CircularProgress variant="determinate" value={(countdown / 5) * 100} />
            <Box
              sx={{
                top: 0,
                left: 0,
                bottom: 0,
                right: 0,
                position: 'absolute',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <Typography variant="caption" component="div" color="text.secondary">
                {countdown}
              </Typography>
            </Box>
          </Box>
        </Box>
      </Paper>
    </Box>
  );
};

export default NotFound; 